module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_04.3a529e72.svg";